unit UWebSpeechRec;

interface

uses
  WebLib.SpeechRecognition, System.Classes, UEssentialHelper;

type
  TSpeechRecCommand = (srcAll, srcLast, srcNumber, srcStore, srcCancel);

  TSpeechRecCommandEvent = procedure(Sender: TObject;
    SpeechRecCommand: TSpeechRecCommand; Parameters: TStrings) of object;
  TSpeechRecNoResultMatchEvent = procedure(Sender: TObject; Phrases: TStrings)
    of object;

  TSpeechRec = class
  private
    FSpeechRec: TSpeechRecognition;
    FOnSpeechRecNoResultMatch: TSpeechRecNoResultMatchEvent;
    FOnSpeechRecCommand: TSpeechRecCommandEvent;
    FOnPropertyChanged: TPropertyChangedEvent;
    FActive: Boolean;
    procedure Command0OnCommand(Sender: TObject; Parameters: TStrings);
    procedure Command1OnCommand(Sender: TObject; Parameters: TStrings);
    procedure Command2OnCommand(Sender: TObject; Parameters: TStrings);
    procedure Command3OnCommand(Sender: TObject; Parameters: TStrings);
    procedure Command4OnCommand(Sender: TObject; Parameters: TStrings);
    procedure DoPropertyChanged(PropertyName: string);
    procedure DoSpeechRecCommand(SpeechRecCommand: TSpeechRecCommand;
      Parameters: TStrings);
    procedure DoSpeechRecNoResultMatch(Phrases: TStrings);
    procedure HandleSpeechRecNoResultMatch(Sender: TObject; Phrases: TStrings);
    procedure SetOnSpeechRecCommand(const Value: TSpeechRecCommandEvent);
    procedure SetOnSpeechRecNoResultMatch(const Value
      : TSpeechRecNoResultMatchEvent);
    procedure SetOnPropertyChanged(const Value: TPropertyChangedEvent);
    procedure SetActive(const Value: Boolean);
  public
    constructor Create;
    procedure Start;
    procedure Stopp;
    property OnSpeechRecCommand: TSpeechRecCommandEvent read FOnSpeechRecCommand
      write SetOnSpeechRecCommand;
    property OnSpeechRecNoResultMatch: TSpeechRecNoResultMatchEvent
      read FOnSpeechRecNoResultMatch write SetOnSpeechRecNoResultMatch;
    property OnPropertyChanged: TPropertyChangedEvent read FOnPropertyChanged
      write SetOnPropertyChanged;
    property Active: Boolean read FActive write SetActive;
  end;

implementation

{ TWebSpeechRec }

procedure TSpeechRec.Command0OnCommand(Sender: TObject;
  Parameters: TStrings);
begin
  Self.DoSpeechRecCommand(srcNumber, Parameters);
end;

procedure TSpeechRec.Command1OnCommand(Sender: TObject;
  Parameters: TStrings);
begin
  Self.DoSpeechRecCommand(srcLast, Parameters);
end;

procedure TSpeechRec.Command2OnCommand(Sender: TObject;
  Parameters: TStrings);
begin
  Self.DoSpeechRecCommand(srcAll, Parameters);
end;

procedure TSpeechRec.Command3OnCommand(Sender: TObject;
  Parameters: TStrings);
begin
  Self.DoSpeechRecCommand(srcStore, Parameters);
end;

procedure TSpeechRec.Command4OnCommand(Sender: TObject;
  Parameters: TStrings);
begin
  Self.DoSpeechRecCommand(srcCancel, Parameters);
end;

constructor TSpeechRec.Create;
var
  cmd: TCommand;
begin
  FSpeechRec := TSpeechRecognition.Create(nil);
  FSpeechRec.Language := 'de-de';
  cmd := TCommand.Create(FSpeechRec.Commands);
  cmd.Tag := 0;
  cmd.Value := 'Lösche Zeile :number';
  cmd.OnCommand := Self.Command0OnCommand;
  cmd := TCommand.Create(FSpeechRec.Commands);
  cmd.Tag := 0;
  cmd.Value := 'Lösche letzte Zeile';
  cmd.OnCommand := Self.Command1OnCommand;
  cmd := TCommand.Create(FSpeechRec.Commands);
  cmd.Tag := 0;
  cmd.Value := 'Lösche alles';
  cmd.OnCommand := Self.Command2OnCommand;
  cmd := TCommand.Create(FSpeechRec.Commands);
  cmd.Tag := 0;
  cmd.Value := 'Speichern';
  cmd.OnCommand := Self.Command3OnCommand;
  cmd := TCommand.Create(FSpeechRec.Commands);
  cmd.Tag := 0;
  cmd.Value := 'Abbruch';
  cmd.OnCommand := Self.Command4OnCommand;
  FSpeechRec.OnNoResultMatch := Self.HandleSpeechRecNoResultMatch;
  FActive := false;
  Self.OnSpeechRecCommand := nil;
  Self.OnSpeechRecNoResultMatch := nil;
  Self.OnPropertyChanged := nil;
end;

procedure TSpeechRec.DoPropertyChanged(PropertyName: string);
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self, PropertyName);
end;

procedure TSpeechRec.DoSpeechRecCommand(SpeechRecCommand: TSpeechRecCommand;
  Parameters: TStrings);
begin
  if Assigned(Self.OnSpeechRecCommand) then
    Self.OnSpeechRecCommand(Self, SpeechRecCommand, Parameters);
end;

procedure TSpeechRec.DoSpeechRecNoResultMatch(Phrases: TStrings);
begin
  if Assigned(Self.OnSpeechRecNoResultMatch) then
    Self.OnSpeechRecNoResultMatch(FSpeechRec, Phrases);
end;

procedure TSpeechRec.HandleSpeechRecNoResultMatch(Sender: TObject;
  Phrases: TStrings);
begin
  Self.DoSpeechRecNoResultMatch(Phrases);
end;

procedure TSpeechRec.SetActive(const Value: Boolean);
begin
  if FActive <> Value then
  begin
    FActive := Value;
    Self.DoPropertyChanged('Active');
  end;
end;

procedure TSpeechRec.SetOnPropertyChanged(const Value
  : TPropertyChangedEvent);
begin
  FOnPropertyChanged := Value;
end;

procedure TSpeechRec.SetOnSpeechRecCommand(const Value
  : TSpeechRecCommandEvent);
begin
  FOnSpeechRecCommand := Value;
end;

procedure TSpeechRec.SetOnSpeechRecNoResultMatch
  (const Value: TSpeechRecNoResultMatchEvent);
begin
  FOnSpeechRecNoResultMatch := Value;
end;

procedure TSpeechRec.Start;
begin
  FSpeechRec.Start;
  Self.Active := true;
end;

procedure TSpeechRec.Stopp;
begin
  FSpeechRec.Abort;
  Self.Active := false;
end;

end.
